import React, { useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import Input from "../../../../../stories/Input/Input";
import {
  CustomModal,
  getModifiedScrollHeight,
  handleMUISelectEvent,
} from "../../../../../utils/UtilFunctions";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../utils/types";
import AssignImage from "../../../../../images/Assign.svg";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import NoData from "../../../../../images/NoData.svg";
import { CustomDrawer } from "../../../../../styles/CustomDrawerStyles";
import Assign from "./Assign";
import View from "./View";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import EyeWhite from "../../../../../images/EyeWhite.svg";
import ItemGroupSelect from "../../../../../customComponents/ItemGroupSelect";
import ItemCategorySelect from "../../../../../customComponents/ItemCategorySelect";
import UoMSelect from "../../../../../customComponents/UoMSelect";
import {
  AtsStckItemEdge,
  AtsStckItemOrderField,
  GetItemsResult,
  GetItemsVars,
  ItemQueryType,
  filterDataType,
} from "../items/queries/types";
import { useLazyQuery } from "@apollo/client";
import { GetItems } from "../items/queries/queries";
import useUrlParams from "../../../../../customHooks/useUrlParams";

import { FETCH_MORE_DATA, ROWS_PER_PAGE, debouncedDelay } from "../../../../../utils/constants";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import LoadingModal from "../../../../pages/LoadingModal";
import Navbar from "../../../../common/layout/Navbar";
import { LicenseTypes } from "../../../../../utils/Enum.types";
import useLabels from "../../../../../customHooks/useLabels";
import { useDebounce } from "../../../../../customHooks/useDebounce";

export interface selectedItemType {
  itemId: number;
  itemDesc: string;
  itemCode: string;
}

const Associate = () => {
  const [associate, setAssociate] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const navigate = useNavigate();
  const { Masters_Table } = useAssetTableJson();

  const { customer_id, company_id } = useUrlParams();


  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [items, setItems] = useState<AtsStckItemEdge[]>([]);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [filterData, setFilterData] = useState<filterDataType>({
    ItemGroupId: 0,
    ItemCategoryId: 0,
    UoMId: 0,
  });
  const [selectedItem, setSelectedItem] = useState<selectedItemType>({
    itemId: 0,
    itemDesc: "",
    itemCode: "",
  });

  const [GetStockItems, { data, loading, fetchMore }] = useLazyQuery<
    GetItemsResult,
    GetItemsVars
  >(GetItems);

  const dynamicHeaders: TableHeaderProps[] =
    Masters_Table.Masters.Association.SupplierToItem.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: (params) => {
        if (header.field === "actions") {
          return (
            <>
              {params.row.ldgr_count > 0 ? (
                <button
                  className="associate-supplier__tableblock--view"
                  onClick={() => {
                    setSelectedItem({
                      itemId: params.row.itemId,
                      itemDesc: params.row.desc,
                      itemCode: params.row.code,
                    });
                    setViewModal(!viewModal);
                  }}
                >
                  View {ledgerLabel} <img src={EyeWhite} alt="" />
                </button>
              ) : (
                <button
                  className="associate-supplier__tableblock--assign"
                  onClick={() => {
                    setSelectedItem({
                      itemId: params.row.itemId,
                      itemDesc: params.row.desc,
                      itemCode: params.row.code,
                    });
                    setAssociate(!associate);
                  }}
                >
                  Assign {ledgerLabel} <img src={AssignImage} alt="" />
                </button>
              )}
            </>
          );
        }

        return params.value;
      },
    }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.ASSOCIATE_TO_SUPPLIER
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.ASSOCIATE_TO_SUPPLIER,
      JSON.stringify(newModel)
    );
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItems.edges;
      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            itemId: node.id,
            desc: node.desc,
            code: node.code,
            item_group: node.groupDetails.groupName,
            item_category: node.categoryDetails.categoryName,
            unit_of_measurement: node.uomDetails.uom,
            ldgr_count: node.ldgr_count,
          }))
        );
      } else {
        setItems(newData);

        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            itemId: node.id,
            desc: node.desc,
            code: node.code,
            item_group: node.groupDetails.groupName,
            item_category: node.categoryDetails.categoryName,
            unit_of_measurement: node.uomDetails.uom,
            ldgr_count: node.ldgr_count,
          }))
        );
      }
      setEndCursor(data.GetItems.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetItems.edges;
              const pageInfo = fetchMoreResult.GetItems.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetItems.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetItems: {
                  edges: [...items, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetItems.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    const fetchData = async () => {
      try {

        if (customer_id || company_id) {
          GetStockItems({
            variables: {
              after: null,
              customerID: customer_id ? customer_id : 0,
              companyID: company_id ? company_id : 0,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckItemOrderField.DESC,
              },
        
              name: debouncedSearch,
              hsnCode: "",
              input: {
                query_type: ItemQueryType.All,
                stckCategoryID: filterData.ItemCategoryId
                  ? filterData.ItemCategoryId
                  : 0,
                stckGroupID: filterData.ItemGroupId
                  ? filterData.ItemGroupId
                  : 0,
                stckManufacturerID: 0,
                stckUomID: filterData.UoMId ? filterData.UoMId : 0,
                stckSubCategoryID: 0,
                ldgrID: 0,
                subsidiaryID: 0,
                isComponent: undefined,
              },
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [customer_id, GetStockItems, debouncedSearch, filterData]);

  const { itemLabel, ledgerLabel } = useLabels();

  return (
    <>
      <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
      <Title>
        Associate {ledgerLabel} to {itemLabel}
      </Title>
      <div className="associate-supplier">
        <div className="associate-supplier__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
            />
          </div>
          <div className="col-2">
            <ItemGroupSelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    ItemGroupId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    ItemGroupId: 0,
                  });
                }
              }}
              value={filterData.ItemGroupId}
              onKeyDown={handleMUISelectEvent}
              label={`${itemLabel} Group`}
            />
          </div>
          <div className="col-2">
            <ItemCategorySelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    ItemCategoryId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    ItemCategoryId: 0,
                  });
                }
              }}
              value={filterData.ItemCategoryId}
              label={`${itemLabel} Category`}
              onKeyDown={handleMUISelectEvent}
            />
          </div>
          <div className="col-2">
            <UoMSelect
              onChange={(newValue) => {
                if (newValue) {
                  setFilterData({
                    ...filterData,
                    UoMId: newValue.value,
                  });
                } else {
                  setFilterData({
                    ...filterData,
                    UoMId: 0,
                  });
                }
              }}
              value={filterData.UoMId}
              label="Unit of Measurement"
              onKeyDown={handleMUISelectEvent}
            />
          </div>
        </div>
        <div className="associate-supplier__tableblock">
          {rows.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <Button mode="back" onClick={() => navigate(-1)} />

        <CustomDrawer
          anchor="right"
          open={associate}
          onClose={() => setAssociate(!associate)}
        >
          <Assign selectedItem={selectedItem} setModalFlag={setAssociate} />
        </CustomDrawer>

        <CustomModal
          isOpen={viewModal}
          onRequestClose={() => setViewModal(!viewModal)}
          contentComponent={
            <View selectedItem={selectedItem} setModalFlag={setViewModal} />
          }
          style={ViewModalStyles}
        />
        <LoadingModal flag={(!searchData &&loading)} />
      </div>
    </>
  );
};

export default Associate;
